import React, { useState, useEffect, useRef } from "react";
import { useStaticQuery, graphql } from "gatsby";
import classNames from "classnames";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";
import Img from "gatsby-image";

import Button from "../../../components/Button/Button";
import "./PartnerShowcaseWidget.css";

const PartnerShowcaseWidget = () => {
    const [imgClassFlag, setImgClassFlag] = useState(false);
    const ImageParentEl = useRef(null);

    const data = useStaticQuery(graphql`
        query PartnerSectionQuery {
            mobileImage: file(relativePath: { eq: "partner-section-mob.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(
                relativePath: { eq: "partner-section-desk.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    useEffect(() => {
        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(
                entries => {
                    if (entries[0].intersectionRatio > 0) {
                        setImgClassFlag(() => true);
                    }
                },
                { threshold: 0.5 }
            );

            observer.observe(ImageParentEl.current);

            return () => {
                observer.disconnect();
            };
        }
    });

    return (
        <WidgetContainer stylesClass="partner-showcase-container">
            <h2 className="partner-showcase-container__title">
                At 11 million + <br /> stores, apps, websites &amp; more
            </h2>
            <div className="partner-showcase-container__btn">
                <Button
                    btnText="Partner with us"
                    pagePath="/business-solutions/"
                />
            </div>
            <div ref={ImageParentEl}>
                <Img
                    fluid={data.desktopImage.childImageSharp.fluid}
                    imgStyle={{ objectFit: "contain" }}
                    className={classNames(
                        "partner-showcase-container__partner-banner",
                        { "add-animation": imgClassFlag }
                    )}
                    loading="eager"
                />
            </div>
            <Img
                fluid={data.mobileImage.childImageSharp.fluid}
                imgStyle={{ objectFit: "contain" }}
                className="partner-showcaseImg-mob"
                loading="eager"
            />
        </WidgetContainer>
    );
};

export default PartnerShowcaseWidget;
